<template>
  <span>{{ params.value }}</span>
</template>

<script>
export default {
  name: "SimpleTextRenderer",
  data() {
    return {
      params: null
    };
  },
  beforeMount() {
    this.params = this.params;
  },
  computed: {}
};
</script>

<style scoped></style>
